
import { granjaApi } from "../../api";
import Swal from "sweetalert2";





export const vehiculoXID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/vehiculo/xid/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const listadoVehiculos = async() => {
    try {
        const { data } = await granjaApi.get('/vehiculo/todos');
        return data.vehiculo;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const setVehiculoXConductor = async(id) => {
    try {
        const { data } = await granjaApi.get(`/vehiculo/xconductor/${id}`);
        return data.data;
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}



export const savingVehiculos = async( vehiculo ) => {
    try {
        if( vehiculo.id ){
            const { data } = await granjaApi.put(`/vehiculo/${ vehiculo.id }`, vehiculo );
            Swal.fire('Exitoso', 'Vehiculo Actualizado', 'success');
            return data.data;
        }else {
            const { data } = await granjaApi.post('/vehiculo/new', vehiculo );
            Swal.fire('Exitoso', 'Vehiculo Creado', 'success');
            return data.data;
        }
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data?.msg || '', 'error');
        return false;
    }
} 


export const deleteVehiculo = async(id) => {
    try {
        const { data } = await granjaApi.put(`/vehiculo/delete/${id}`);
        Swal.fire('Exitoso', 'Vehiculo Bloqueado', 'success');
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error);
    }
}





